'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    (0, _jquery2.default)(document).on('mouseover', 'span[data-toggle="thumbnail-hover"]', function (e) {

        var position = "top";
        var $t = (0, _jquery2.default)(this);
        var target = $t.data("target");
        var title = $t.data("title");

        if ($t.position().top < 230) {
            position = "bottom";
        } else {
            position = "top";
        }

        (0, _jquery2.default)(this).tooltip({
            title: '<img src=\'' + target + '\' alt=\'' + title + '\'>',
            html: true,
            placement: position
        });
    });

    (0, _jquery2.default)(document).tooltip({
        selector: 'span[data-toggle="thumbnail-hover"]',
        delay: 0,
        placement: "right",
        title: '',
        html: true
    });
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/onHoverDynamicShowThumbnail.js
// module id = 445
// module chunks = 0